import { BUSINESS_TOOL_SECTIONS, BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';

import { IOptionType } from 'interfaces/forms';

export const prefix = `${BUSINESS_TOOL_SECTIONS.OVERVIEW}.${BUSINESS_TOOL_SUB_SECTIONS.OVERVIEW.PROJECT}` as const;

export const COMPANY_PROJECT_NAMES = {
  STATUS: 'status',
} as const;

export interface IProjectOverviewForm {
  [COMPANY_PROJECT_NAMES.STATUS]: IOptionType[];
}

export const overviewProjectInitialValues: IProjectOverviewForm = {
  [COMPANY_PROJECT_NAMES.STATUS]: [],
};